import Intercom, { show, showNewMessage, shutdown } from '@intercom/messenger-js-sdk'

/**
 * The app's one way to talk to the Intercom messenger.
 *
 * The SDK was imported directly in four places before this, each doing its own
 * thing with it. Support is the fallback destination for several Home states
 * ("Message support", "Question this charge"), so it needs a single call that
 * behaves the same everywhere.
 */

/** Open the messenger. No-ops when Intercom is not booted (e.g. no app id). */
export function openIntercom(): void {
  try {
    show()
  } catch {
    // Not booted — missing VITE_INTERCOM_APP_ID locally, or the script was
    // blocked. A support button that silently does nothing is better than one
    // that throws into the founder's console.
  }
}

/** Open the messenger with a message ready to send. */
export function openIntercomWithMessage(message: string): void {
  try {
    showNewMessage(message)
  } catch {
    // Same as openIntercom: not booted, nothing to do.
  }
}

export { Intercom, shutdown }
